// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "21c93d17bf534abaa2499b9fa126c3305323f779/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};